module.exports = __webpack_public_path__ + "static/media/abstract2.9a910c80.jpg";